import { t } from 'i18next';
import React from 'react';
import { Processing } from 'src/components/Feedback';

export const LoadingScreen = () => {
  return (
    <Processing
      message={t('MandateProcessing')}
      title={t('MandateCreateProcessing')}
    />
  );
};
